function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M1.5 8.8a15 15 0 0 1 21 0"
});

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M5 12.4a10 10 0 0 1 14 0"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.6 15.9a5 5 0 0 1 6.8 0"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 19.5,
  r: 1.1,
  fill: "currentColor",
  stroke: "none"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("line", {
  className: "no-connection-knockout",
  x1: 3,
  y1: 3,
  x2: 21,
  y2: 21,
  stroke: "#FFFFFF",
  strokeWidth: 5
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("line", {
  x1: 3,
  y1: 3,
  x2: 21,
  y2: 21
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default __webpack_public_path__ + "static/media/no-connection.d6c2d9f2.svg";
export { SvgComponent as ReactComponent };